"use client"

import { useMemo, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import "bootstrap-icons/font/bootstrap-icons.css"
import "./Blog.css"

import { articles } from "./blogData"

const categories = ["All", ...new Set(articles.map((article) => article.category))]

const Blog = () => {
  const [activeCategory, setActiveCategory] = useState("All")

  const visibleArticles = useMemo(
    () =>
      activeCategory === "All"
        ? articles
        : articles.filter((article) => article.category === activeCategory),
    [activeCategory],
  )

  return (
    <section className="blog-section" aria-labelledby="blog-heading">
      <div className="blog-orb blog-orb-one" />
      <div className="blog-orb blog-orb-two" />

      <div className="container blog-container">
        <div className="blog-heading-row">
          <div className="blog-heading-copy">
            <span className="blog-eyebrow">
              <i className="bi bi-journal-richtext" aria-hidden="true" />
              The Katchit Edit
            </span>
            <h2 id="blog-heading">Fresh stories for a better day out</h2>
            <p>
              Local food finds, celebration ideas and smarter ways to get things
              done—all curated by Katchit.
            </p>
          </div>

          <a className="blog-app-link" href="#contact">
            Stay in the loop
            <i className="bi bi-arrow-up-right" aria-hidden="true" />
          </a>
        </div>

        <div className="blog-tabs" role="tablist" aria-label="Blog categories">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              role="tab"
              aria-selected={activeCategory === category}
              className={`blog-tab ${activeCategory === category ? "blog-tab-active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <motion.div layout className="blog-grid">
          <AnimatePresence mode="popLayout">
            {visibleArticles.map((article, index) => (
              <motion.article
                layout
                key={article.id}
                className={`blog-card ${article.featured && activeCategory === "All" ? "blog-card-featured" : ""}`}
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.97 }}
                transition={{ duration: 0.35, delay: index * 0.04 }}
              >
                <a
                  className="blog-card-overlay"
                  href={`/blog/${article.slug}`}
                  aria-label={`Read ${article.title}`}
                />
                <div className="blog-card-media">
                  <img src={article.image} alt="" />
                  <span className="blog-card-category">{article.category}</span>
                  {article.featured && activeCategory === "All" && (
                    <span className="blog-featured-pill">
                      <i className="bi bi-stars" aria-hidden="true" /> Featured
                    </span>
                  )}
                </div>

                <div className="blog-card-content">
                  <span className="blog-read-time">
                    <i className="bi bi-clock" aria-hidden="true" />
                    {article.readTime}
                  </span>
                  <h3>{article.title}</h3>
                  <p>{article.excerpt}</p>
                  <span className="blog-coming-soon">
                    Read full story
                    <i className="bi bi-arrow-right" aria-hidden="true" />
                  </span>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>

        <div className="blog-note">
          <span className="blog-note-icon">
            <i className="bi bi-lightbulb" aria-hidden="true" />
          </span>
          <div>
            <strong>Have a story worth sharing?</strong>
            <p>Tell us about your favourite local food spot or Katchit experience.</p>
          </div>
          <a href="#contact">Share your story</a>
        </div>
      </div>
    </section>
  )
}

export default Blog
